import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { StorageService } from '@services/core/storage.service';
import { BudgetVersionModel } from '@model/budget-version.model';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { BudgetEmployeeTypeModel } from '@model/budget-employee-type.model';
import { BudgetFundModel } from '@model/budget-fund.model';
import { tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})

export class UserService {
   authMicrosoft = inject(MicrosoftAuthService)
  public userData = signal(null)
  public userPhoto = signal<string | null>(null)
  public sharingIdentity = signal({})
  public sharingEntity = signal({})
  public sharingEntities = signal<[]>([])
  public sharingLanguage = signal({})
  public sharingRole = signal({});
  public sharingBudgetVersion =signal(<BudgetVersionModel|null>(null));
  public sharingEmployeeType =signal(<BudgetEmployeeTypeModel|null>(null));
  public sharingBudgetFund =signal(<BudgetFundModel|null>(null));
  public sharingMenu = signal<[]>([])
  public sharingMenuPath = signal({})
  public token;
  public url: string;
  storageService = inject(StorageService)

  constructor(
    private _http: HttpClient

  ) { 
     this.url = Global.url_app;
     this.token = this.storageService.getJsonValue("token") 
    }


  processUserData(userData?: any) {
    if(userData) this.userData.set(userData)
  }

  processUserPhoto(arrayBuffer?: ArrayBuffer) {
    const url = this.arrayBufferToUrl(arrayBuffer);
    this.userPhoto.set(url)
  }

  private arrayBufferToUrl(arrayBuffer: ArrayBuffer): string {
    const array = new Uint8Array(arrayBuffer);
    const blob = new Blob([array], { type: "image/jpeg" });
    return URL.createObjectURL(blob);
  }

  changeEntity(params): Observable<any> {
    let headers = new HttpHeaders()
     .set('Content-Type', 'application/json')
     .set('Authorization', this.token);
     let result=this._http.put(this.url+'user/',params ,{ headers: headers });
   return result
 }




refreshBudgetVersion() {
  return this.authMicrosoft.decryptToken().pipe(
    tap(res => {    
      this.processUserData(res.user.user);
      this.processUserPhoto(res.photo.body.data);
      this.sharingEntities.set(res.user.entities);
      this.sharingEntity.set(res.user.entity);
      this.sharingIdentity.set(res.user.identity);
      this.sharingBudgetVersion.set(res.user.budgetVersion[0]);
      this.sharingEmployeeType.set(res.user.employeeType);
      this.sharingMenu.set(res.user.menu);
      this.storageService.setJsonValue('menu', res.user.menu);
      this.sharingRole.set(res.user.role);
      this.sharingBudgetFund.set(res.user.budgetFund);
      this.storageService.setJsonValue('role', res.user.role);
    })
  );
}



}
